<template>
  <div
    :class="['modern-search-box', 'hc-no-form-icons', { 'is-fluid': fluid }]"
  >
    <div class="modern-search-control">
      <i class="fas fa-search" aria-hidden="true"></i>
      <b-form-input
        type="text"
        :value="value"
        :placeholder="placeholder"
        :aria-label="ariaLabel || placeholder"
        autocomplete="off"
        class="modern-search-input"
        @input="$emit('input', $event)"
        @keyup="$emit('keyup', $event)"
      />
    </div>
    <small v-if="hint" class="sr-only">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  name: "ModernSearchInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Cari..."
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    fluid: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.modern-search-box {
  --modern-search-accent: #16867f;
  --modern-search-border: #dbe4ec;
  --modern-search-text: #334155;
  --modern-search-muted: #8a9aab;
  position: relative;
  flex: 0 1 230px;
  width: 230px;
  min-width: 230px;
  max-width: 230px;
}

.modern-search-box.is-fluid {
  flex: 1 1 auto;
  width: 100%;
  max-width: none;
}

.modern-search-control {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
}

#kt_content .modern-search-box .modern-search-control input.modern-search-input,
.modern-search-box .modern-search-control input.modern-search-input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 0.75rem 0 2.45rem !important;
  border: 1px solid var(--modern-search-border) !important;
  border-radius: 10px !important;
  outline: 0;
  background: #fff !important;
  box-shadow: none !important;
  color: var(--modern-search-text) !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

#kt_content .modern-search-box .modern-search-control input.modern-search-input:focus,
.modern-search-box .modern-search-control input.modern-search-input:focus {
  border-color: var(--modern-search-accent) !important;
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.09) !important;
}

#kt_content .modern-search-box .modern-search-control input.modern-search-input::placeholder,
.modern-search-box .modern-search-control input.modern-search-input::placeholder {
  color: var(--modern-search-muted) !important;
  font-weight: 300 !important;
  opacity: 1;
}

.modern-search-control > i {
  position: absolute;
  top: 50%;
  left: 0.82rem;
  z-index: 2;
  transform: translateY(-50%);
  color: var(--modern-search-accent) !important;
  font-size: 0.86rem;
  pointer-events: none;
}

.modern-search-box .hc-form-field-icon {
  display: none !important;
}

@media (max-width: 991.98px) {
  .modern-search-box {
    flex: 1 1 230px;
    width: auto;
    min-width: 190px;
    max-width: none;
  }
}

@media (max-width: 575.98px) {
  .modern-search-box {
    width: 100%;
    min-width: 0;
  }
}
</style>
